import React, { useState, useEffect } from 'react';
import '../styles/loader.css';

const Loader = ({ onLoadComplete }) => {
  const [isVisible, setIsVisible] = useState(true);
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    // Start fade out at 4.5 seconds
    const fadeTimer = setTimeout(() => {
      setFadeOut(true);
    }, 2500);

    // Complete removal at 5 seconds
    const completeTimer = setTimeout(() => {
      setIsVisible(false);
      if (onLoadComplete) {
        onLoadComplete();
      }
    }, 3000);

    return () => {
      clearTimeout(fadeTimer);
      clearTimeout(completeTimer);
    };
  }, [onLoadComplete]);

  if (!isVisible) return null;

  return (
    <div className={`loader-wrapper ${fadeOut ? 'fade-out' : ''}`}>
      <div className="loader-content">
        {/* Animated Background Circles */}
        <div className="loader-bg-circle circle-1"></div>
        <div className="loader-bg-circle circle-2"></div>
        <div className="loader-bg-circle circle-3"></div>

        {/* Logo Container */}
        <div className="loader-logo-container">
          <div className="loader-logo-ring">
            <div className="loader-logo-ring-inner"></div>
          </div>
          <img 
            src={require('../assets/Logo2.png')} 
            alt="Aashman Technicals Logo" 
            className="loader-logo"
          />
        </div>

        {/* Company Name */}
        <h1 className="loader-title">
          <span className="loader-title-main">Aashman Technicals</span>
          <span className="loader-title-sub">Pvt. Ltd.</span>
        </h1>

        {/* Tagline */}
        <p className="loader-tagline">Advanced Robotics Solutions</p>

        {/* Progress Bar */}
        <div className="loader-progress-container">
          <div className="loader-progress-bar"></div>
        </div>

        {/* Loading Text */}
        <div className="loader-text">
          <span className="loader-dot">.</span>
          <span className="loader-dot">.</span>
          <span className="loader-dot">.</span>
        </div>
      </div>
    </div>
  );
};

export default Loader;